import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Alert, Spinner } from "reactstrap";
import { useSearchParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VerifyEmailChange = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");
      const userId = searchParams.get("userId");

      if (!token || !userId) {
        setStatus("error");
        setMessage("Invalid verification link. Missing required parameters.");
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE}/dashboard/auth/email/confirm?userId=${userId}&token=${token}`,
          {
            method: "GET",
          }
        );

        const data = await response.json();

        if (response.ok) {
          setStatus("success");
          setMessage(data.message || "Email successfully changed");

          // Refresh the page after 3 seconds
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          setStatus("error");
          setMessage(data.message || "Failed to verify email change");
        }
      } catch (error) {
        console.error("Error verifying email:", error);
        setStatus("error");
        setMessage("An error occurred while verifying your email change.");
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay"></div>
      </div>

      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <a href="/" className="d-inline-block auth-logo">
                    <img
                      src="/logo192.png"
                      alt=""
                      height="20"
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Email Verification</h5>
                    <p className="text-muted">
                      {status === "loading" && "Verifying your email change..."}
                      {status === "success" && "Email Change Confirmed"}
                      {status === "error" && "Verification Failed"}
                    </p>
                  </div>

                  <div className="p-2 mt-4">
                    {status === "loading" && (
                      <div className="text-center">
                        <Spinner color="primary" />
                        <p className="text-muted mt-3">
                          Please wait while we verify your email change...
                        </p>
                      </div>
                    )}

                    {status === "success" && (
                      <Alert color="success" className="text-center">
                        <i className="ri-checkbox-circle-line me-2 align-middle fs-16"></i>
                        {message}
                        <div className="mt-3">
                          <p className="mb-0">
                            Refreshing...
                          </p>
                        </div>
                      </Alert>
                    )}

                    {status === "error" && (
                      <Alert color="danger" className="text-center">
                        <i className="ri-error-warning-line me-2 align-middle fs-16"></i>
                        {message}
                        <div className="mt-3">
                          <a href="/login" className="btn btn-primary btn-sm">
                            Go to Login
                          </a>
                        </div>
                      </Alert>
                    )}
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Need help?{" "}
                  <a
                    href="/contact"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    Contact Support
                  </a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default VerifyEmailChange;
